import { useDroppable } from "@dnd-kit/core";

const ContainerDropArea = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  console.log(isOver);

  return (
    <div
      ref={setNodeRef}
      style={{
        minWidth: "242px",
        minHeight: "200px",
        // minHeight: `calc(100vh - 5.6rem)`,
        width: "auto",
        overflow: "auto",
        // border: "2px dashed #ccc",
        backgroundColor: isOver ? "#e6f7ff" : "#f0f0f0",
        padding: "10px",
        position: "relative",
        transition: "background-color 0.3s ease-in-out",
      }}
    >
      <div>{children}</div>
    </div>
  );
};

export default ContainerDropArea;
